import { DefaultTheme } from '../theme';
import { CSS as InputCSS } from './input.style';

export const CSS = {
	container: 'c-MultiListInput',
	label: 'c-MultiListInput__label',
	button: 'c-MultiListInput__button',
	edit: 'c-MultiListInput__edit',
	colorIndicator: 'c-MultiListInput__colorIndicator',
};

export const Style = {
	[CSS.container]: {
		display: 'flex',
		flex: 1,
		'align-items': 'center',
		'justify-content': 'space-between',
		[`& .${InputCSS.container}`]: {
			cursor: 'pointer',
		},
	},
	[CSS.button]: {
		flex: 1,
		display: 'flex',
		'font-family': DefaultTheme.font.familyCondensed,
		'font-size': DefaultTheme.font.size,
		height: DefaultTheme.space(5),
		'line-height': DefaultTheme.space(5),
		'align-items': 'center',
		'justify-content': 'space-between',
		'text-align': 'left',
		padding: 0,
		color: 'inherit',
		'font-weight': 'normal',
		'text-transform': 'none',
	},
	[CSS.label]: {
		overflow: 'hidden',
		flex: 1,
		'text-overflow': 'ellipsis',
	},
	[CSS.edit]: {
		transform: 'rotate(-90deg)',
		'font-size': 'inherit',
		color: DefaultTheme.font.color.divider,
	},
	[CSS.colorIndicator]: {
		width: DefaultTheme.space(3),
		height: DefaultTheme.space(3),
		'border-radius': '50%',
		marginRight: DefaultTheme.space(2),
	},
};
